/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoUpdateContactInput = {
    clientMutationId?: string | null;
    slug: string;
    contactType: string;
    format: string;
    salutation: string;
    imageSlug?: string | null;
    firstName: string;
    lastName: string;
    email?: string | null;
    secondaryEmails?: Array<string> | null;
    businessPhone?: string | null;
    mobilePhone?: string | null;
    privatePhone?: string | null;
    faxPhone?: string | null;
    zollContactNumber?: string | null;
    zollPhone?: string | null;
    atbForCustoms?: boolean | null;
    company?: string | null;
    position?: string | null;
    country: string;
    state?: string | null;
    place?: string | null;
    postcode?: string | null;
    address?: string | null;
    language?: string | null;
    lexOfficeId?: string | null;
    eori?: string | null;
    vat?: string | null;
    website?: string | null;
    note?: string | null;
    roles: Array<string>;
    rateCardSlug?: string | null;
    freeWarehousingDays?: number | null;
    costWarehousingPerDay?: number | null;
    costShipmentDischarge?: number | null;
    vatWarehousing?: boolean | null;
    vatRevenues?: boolean | null;
    customsOffice?: string | null;
    syncWithEmory?: boolean | null;
    blocked?: boolean | null;
    expenses?: number | null;
};
export type ContactEditMutationVariables = {
    input: infoUpdateContactInput;
};
export type ContactEditMutationResponse = {
    readonly infoUpdateContact: {
        readonly contact: {
            readonly slug: string;
        };
    } | null;
};
export type ContactEditMutation = {
    readonly response: ContactEditMutationResponse;
    readonly variables: ContactEditMutationVariables;
};



/*
mutation ContactEditMutation(
  $input: infoUpdateContactInput!
) {
  infoUpdateContact(input: $input) {
    contact {
      slug
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContactEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "infoUpdateContactPayload",
        "kind": "LinkedField",
        "name": "infoUpdateContact",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "contact",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContactEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "infoUpdateContactPayload",
        "kind": "LinkedField",
        "name": "infoUpdateContact",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "contact",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4184f36aab1640ab94555d9516f4ec17",
    "id": null,
    "metadata": {},
    "name": "ContactEditMutation",
    "operationKind": "mutation",
    "text": "mutation ContactEditMutation(\n  $input: infoUpdateContactInput!\n) {\n  infoUpdateContact(input: $input) {\n    contact {\n      slug\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '9c81f05661ecb191af2aec6a15297e0a';
export default node;
